<template>
    <q-list>
        <q-collapsible class="filter" icon="fal fa-filter" :label="$t('filter')" :opened="!$q.platform.is.mobile ? true : false">
            <q-list no-border>
                <q-item>
                    <q-item-main>
                        <q-search v-model="search" :placeholder="$t('search')" icon="fal fa-search" @input="changeFilter" :debounce="600" />
                    </q-item-main>
                </q-item>

                <q-item>
                    <q-item-main>
                        <p class="caption">{{ $t('progress') }}</p>
                        <q-btn-toggle
                            class="full-width q-mb-sm progress"
                            v-model="progress"
                            toggle-color="primary"
                            :options="[
                                {label: $t('all'), value: 'all', icon: 'fal fa-list'}
                            ]"
                            @input="changeFilter"
                        />
                        <q-btn-toggle
                            class="full-width q-mb-sm progress"
                            v-model="progress"
                            toggle-color="primary"
                            :options="[
                                {label: $t('listening'), value: 'in-progress', icon: 'fal fa-play-circle'}
                            ]"
                            @input="changeFilter"
                        />
                        <q-btn-toggle
                            class="full-width q-mb-sm progress"
                            v-model="progress"
                            toggle-color="primary"
                            :options="[
                                {label: $t('to_listen'), value: 'to-do', icon: 'fal fa-pause-circle'}
                            ]"
                            @input="changeFilter"
                        />
                        <q-btn-toggle
                            class="full-width q-mb-sm progress"
                            v-model="progress"
                            toggle-color="primary"
                            :options="[
                                {label: $t('listened'), value: 'finished', icon: 'fal fa-stop-circle'}
                            ]"
                            @input="changeFilter"
                        />
                    </q-item-main>
                </q-item>

                <q-item>
                    <q-item-main>
                        <p class="caption">{{ $t('favorites') }}</p>
                        <q-btn-toggle
                            class="full-width q-mb-sm progress"
                            v-model="favorite"
                            toggle-color="primary"
                            :options="[
                                {label: $t('all'), value: 'all', icon: 'fal fa-list'}
                            ]"
                            @input="changeFilter"
                        />
                        <q-btn-toggle
                            class="full-width q-mb-sm progress"
                            v-model="favorite"
                            toggle-color="primary"
                            :options="[
                                {label: $t('favorites'), value: 'favorites', icon: 'fal fa-heart'}
                            ]"
                            @input="changeFilter"
                        />
                    </q-item-main>
                </q-item>

                <q-item v-if="country_areas.length > 0">
                    <q-item-main>
                        <p class="caption">{{ $t('knowledge_areas') }}</p>
                        <q-item tag="label" v-for="(area, index) in country_areas" :key="index" link>
                            <q-item-side>
                                <q-checkbox v-model="areas" :val="area.value" @input="changeFilter" />
                            </q-item-side>
                            <q-item-main>
                                <q-item-tile label class="text-weight-light">{{ area.label }}</q-item-tile>
                            </q-item-main>
                        </q-item>
                    </q-item-main>
                </q-item>

                <q-item v-if="groups_user.length > 0">
                    <q-item-main>
                        <p class="caption">{{ $t('groups') }}</p>
                        <q-item tag="label" v-for="(group, index) in groups_user" :key="index" link>
                            <q-item-side>
                                <q-checkbox v-model="groups" :val="group.value" @input="changeFilter" />
                            </q-item-side>
                            <q-item-main>
                                <q-item-tile label class="text-weight-light">{{ group.label }}</q-item-tile>
                            </q-item-main>
                        </q-item>
                    </q-item-main>
                </q-item>

                <q-item>
                    <q-item-main>
                        <p class="text-center">
                            <a href="#" @click.prevent="clearFilters()" class="text-faded">
                                <q-icon name="fal fa-trash-alt" /> {{ $t('clear_filters') }}
                            </a>
                        </p>
                    </q-item-main>
                </q-item>
            </q-list>
        </q-collapsible>
    </q-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            search: '',
            progress: 'all',
            favorite: 'all',
            areas: [],
            groups: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            country_areas: 'site_lists/country_areas',
            groups_user: 'site_lists/groups_user',
            store_search: 'podcasts/search',
            store_progress: 'podcasts/progress',
            store_favorite: 'podcasts/favorite',
            store_selected_areas: 'podcasts/selected_areas',
            store_selected_groups: 'podcasts/selected_groups'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        changeFilter() {
            this.$store.dispatch('podcasts/SET_FILTERS', [this.search, this.progress, this.favorite, this.areas, this.groups])
            this.$emit('changeFilter')
        },

        clearFilters() {
            this.$store.dispatch('podcasts/SET_FILTERS', ['', 'all', 'all', [], []])
            this.$emit('changeFilter')
            this.search   = '',
            this.progress = 'all',
            this.favorite = 'all',
            this.areas    = [],
            this.groups   = []
        },
    },

    created() {
        this.clearFilters()
        this.search = this.store_search
        this.progress = this.store_progress
        this.favorite = this.store_favorite
        this.areas = Object.assign([], this.store_selected_areas)
        this.groups = Object.assign([], this.store_selected_groups)
    }
}
</script>

<style lang="stylus" scoped>
p
    margin 0 0 10px

p
    &.tags
        margin 0 0 5px

a
    text-decoration none
</style>
